module.exports = __webpack_public_path__ + "static/media/IMG_022.17190ace.PNG";